<template>

  <InputSwitch
    :trueValue="!invert"
    :falseValue="invert"
    :pt="{
      slider: ({ props, state }) => ({
        class: [
          props.modelValue ? onColor:offColor,
          state.focused ? focusClass:''
        ]
      })
    }"
    v-tooltip.top="{
      value: tooltipText,
      autoHide: false,
      pt: {
        text: 'font-semibold tracking-wider bg-gray-600 px-2 py-1 text-xs'
      }
    }"
  />

</template>

<script>

import InputSwitch from 'primevue/inputswitch';

export default {
  name: "RpmSwitchInput",
  components: {
    InputSwitch
  },
  data() {
    return {};
  },
  props: {
    invert: {
      type: Boolean,
      default: false
    },
    tooltipText: {
      type: String,
      default: ""
    },
    focusClass: {
      type: String,
      default: ""
    },
    placeHolderClass: {
      type: String,
      default: ""
    },
    focusFocusClass: {
      type: String,
      default: ""
    },
    transitionClass: {
      type: String,
      default: ""
    },
    paddingClass: {
      type: String,
      default: ""
    },
    borderClass: {
      type: String,
      default: ""
    },
    panelClass: {
      type: String,
      default: ""
    },
    textClass: {
      type: String,
      default: ""
    },
    onColor: {
      type: String,
      default: "bg-theme"
    },
    offColor: {
      type: String,
      default: "dark:bg-white/20"
    },
    size: {
      type: [String, Number],
      default: 2
    },
  },
};
</script>
